import { useLanguage } from "@/i18n/LanguageContext";
import { Section } from "@/components/shared";
import { ProductCards } from "@/pages/Home";

const Products = () => {
  const { t } = useLanguage();
  return (
    <div data-testid="products-page">
      <Section eyebrow={t("productsPage.eyebrow")} title={t("productsPage.title")} sub={t("productsPage.sub")} className="pt-20 sm:pt-28 grid-bg">
        <ProductCards detailed />
      </Section>
    </div>
  );
};

export default Products;
